/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_Install_Profile_TitleInputs */

const cs_pwa_install_profile_title = /** @type {(inputs: Pwa_Install_Profile_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nainstalovat na toto zařízení`)
};

const en_pwa_install_profile_title = /** @type {(inputs: Pwa_Install_Profile_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install on this device`)
};

/**
* | output |
* | --- |
* | "Install on this device" |
*
* @param {Pwa_Install_Profile_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pwa_install_profile_title = /** @type {((inputs?: Pwa_Install_Profile_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_Install_Profile_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pwa_install_profile_title(inputs)
	return cs_pwa_install_profile_title(inputs)
});